/**
 * Created by mac on 1/4/22
 */

cleverapps.styles.FONTS.SYSTEM = {
    type: {
        name: "Arial"
    },
    size: 20,
    color: cleverapps.styles.COLORS.BLACK
};

cc.Base.prototype.debugGetName = function () {
    if (this.debugId) {
        return this.debugId;
    }

    const ClassObject = this.constructor;

    let res = "[unknown]";
    [window, cc, cleverapps, cleverapps.UI, sp, levels].forEach((root) => {
        for (const i in root) {
            if (root[i] === ClassObject) {
                res = i;
                break;
            }
        }
    });

    return res;
};

cc.Base.prototype.debugParents = function () {
    const res = [];
    let object = this;
    while (object) {
        res.push(object.debugGetName());
        object = object.parent;
    }

    console.log(`cleverapps.sceneDebugger.selectedNode -> ${res.join("->")}`);
};

cc.Base.GetHierarchy = function (startNode) {
    const hierarchy = [];
    let node = startNode;

    while (node) {
        hierarchy.push(node);
        node = node.parent;
    }

    return hierarchy;
};

cc.Base.prototype.debugBorder = function (options) {
    if (!cleverapps.config.debugMode) {
        return;
    }

    options = options || {};

    if (typeof selectedNode === "object" && typeof selectedNode.unselect === "function" && selectedNode !== this && !selectedNode.stopListeners) {
        selectedNode.unselect();
    }

    selectedNode = this;

    if (cleverapps.toolModel.isOpened()) {
        cleverapps.toolModel.refresh();
    }

    if (cleverapps.nodeAttributesPannel) {
        cleverapps.nodeAttributesPannel.remove();
        cleverapps.nodeAttributesPannel = undefined;
    }

    this.debugBorderDx = this.debugBorderDx || 0;
    this.debugBorderDy = this.debugBorderDy || 0;
    if (typeof EditorMap2dDecoratorView !== "undefined" && this instanceof EditorMap2dDecoratorView) {
        this.debugBorderDx = this.decorator.dx || 0;
        this.debugBorderDy = this.decorator.dy || 0;
    }

    const valueToFixed = function (value) {
        return +(value).toFixed(2);
    };

    const getMsg = function (separator) {
        const size = this.getBoundingBox();
        let mergeUnit;
        if (typeof UnitView !== "undefined" && this instanceof UnitView) {
            mergeUnit = ` ${this.unit.getType()} ${Unit.GetKey(this.unit)}`;
            const comp = this.unit.components.map((item) => item.constructor.name).join(" ");
            mergeUnit += comp ? `\n${comp}` : "";
        } else if (this.debugUnitImage && this.debugUnitImage.code !== undefined) {
            mergeUnit = ` unit ${this.debugUnitImage.code}_${this.debugUnitImage.stage}`;
        }

        const msg = [
            this.debugGetName() + (this instanceof cc.LabelTTF ? ` ${this.getFontSize()}` : "") + (mergeUnit || "") + (this instanceof cleverapps.Spine && this._verts ? ` ${this._verts} verts` : ""),
            `${valueToFixed(size.width)}x${valueToFixed(size.height)} (${this.width}x${this.height})`,
            `scale: ${Math.ceil(this.scaleX * 100) / 100} x ${Math.ceil(this.scaleY * 100) / 100}`,
            `pos: ${Math.floor(this.x * 100) / 100} x ${Math.floor(this.y * 100) / 100}`,
            `offset: ${Math.floor(this.debugBorderDx * 100) / 100} x ${Math.floor(this.debugBorderDy * 100) / 100}`,
            `rotation ${this.rotation}`
        ];

        const cell = this.decorator;
        if (cell && cell.x !== undefined && cell.y !== undefined) {
            msg.push(`cell: ${cell.x} x ${cell.y}`);
        }
        console.log(msg.join(separator));
        return msg.join(separator);
    }.bind(this);

    const updateDisplayData = function () {
        console.log(getMsg("\t"));
        if (this.labelSavedPtr && options.showPosition) {
            this.labelSavedPtr.setString(getMsg("\n"));
        }
    }.bind(this);

    // Use HTML5 keyboard events directly for debug UI
    this.debugBorderKeyHandler = (event) => {
        const key = event.keyCode;

        for (const name in cleverapps.NodeDebugCommands) {
            const command = cleverapps.NodeDebugCommands[name];

            if (command.filter && !command.filter.call(this)) {
                continue;
            }

            if (command.key === key && command.toggle) {
                command.toggle.call(this);
                break;
            }

            if ([InputDispatcher.KEY.up, InputDispatcher.KEY.down, InputDispatcher.KEY.right, InputDispatcher.KEY.left].indexOf(key) !== -1) {
                if (command.key === undefined || cleverapps.inputDispatcher.isPressed(command.key)) {
                    command.action.call(this, key);

                    if (!command.noDisplayUpdate) {
                        updateDisplayData();
                    }

                    if (this.spriteSavedPtr) {
                        this.spriteSavedPtr.setContentSize(this.getContentSize());
                    }

                    break;
                }
            }
        }
    };

    document.addEventListener("keydown", this.debugBorderKeyHandler);

    const dpr = cleverapps.resolution.devicePixelRatio;
    const labelDPR = engine === "cocos2d" && dpr > 1
        ? dpr : 1;

    if (!this.spriteSavedPtr) {
        const contentSize = this.getContentSize();

        const pseudo = PseudoRandom.GET(this.debugGetName().length);
        const colors = [new cc.Color(255, 0, 0, 255), new cc.Color(255, 0, 255, 0), new cc.Color(255, 255, 0, 0)];
        let color = options.color || pseudo.choose(colors);
        const isFont = cleverapps.oneOf(this, cc.LabelTTF, cleverapps.UI.ImageFont);

        if (this._slotName || isFont) {
            color = new cc.Color(41, 147, 207);
        }

        let sprite;
        if (contentSize.width === 0 && contentSize.height === 0) {
            sprite = new cc.DrawNode();
            sprite.drawDot(cc.p(0, 0), 5, color);
        } else if (this._slotName || isFont) {
            sprite = new cc.Scale9Sprite(bundles.pixel.frames.pixel_png);
            sprite.setAnchorPoint(0, 0);
            sprite.setOpacity(120);
            sprite.setContentSize(contentSize);
        } else {
            sprite = cleverapps.UI.createScale9Sprite(bundles.dev_resources.frames.border, cleverapps.UI.Scale9Rect.TwoPixelY);
            sprite.setAnchorPoint(0, 0);
            sprite.setContentSize(contentSize);
        }
        this.spriteSavedPtr = sprite;

        sprite.setColor(color);

        if (this instanceof cleverapps.Spine) {
            sprite.setColor(new cc.Color(255, 255, 0, 0));
        }

        if (isFont) {
            const fontDPR = cleverapps.oneOf(this, cc.LabelTTF) ? labelDPR : 1;
            sprite.setScale(fontDPR);

            const dimensions = this.getDimensions();
            if (dimensions.width || dimensions.height) {
                sprite.setContentSize(dimensions.width || this.width, dimensions.height || this.height);
                sprite.setAnchorPoint(0.5, 0.5);
                sprite.setPosition(this.width * fontDPR / 2, this.height * fontDPR / 2);
            }
        }

        const buttons = this.debugButtons = this.createEditButtons(options);
        if (buttons) {
            buttons.setAnchorPoint(0, 1);
            buttons.setAlignment(sprite.width, sprite.height);
            sprite.addChild(buttons);

            if (options.buttonsGlobalZOrder) {
                buttons._setGlobalZOrder(true);
            }
        }

        this.addChild(sprite);
        sprite.setLocalZOrder(10);

        const unitView = typeof UnitView !== "undefined" && cc.Base.GetHierarchy(this).find((node) => node instanceof UnitView);
        if (unitView && unitView.showTouchArea) {
            unitView.showTouchArea();
        }

        if (options.slots && this.slots) {
            Object.keys(this.slots).forEach((slotName) => {
                const slot = this.slots[slotName];

                const sprite = cleverapps.UI.createScale9Sprite(bundles.dev_resources.frames.border, cleverapps.UI.Scale9Rect.TwoPixelY);
                sprite.setLocalZOrder(10);
                sprite.setAnchorPoint(0, 0);
                sprite.setContentSize(slot.width, slot.height);
                slot.addChild(sprite);

                const label = cleverapps.UI.generateOnlyText(slotName, cleverapps.styles.FONTS.SYSTEM);
                label.setAnchorPoint(0, 0);
                label.setPosition(0, sprite.height);
                sprite.addChild(label);
            });
        }
    }

    this.spriteSavedPtr.permanent = this.spriteSavedPtr.permanent || options.permanent;

    if (!this.labelSavedPtr && options.labelText !== false) {
        let labelText;

        if (options.labelText) {
            labelText = options.labelText;
        } else if (options.showZOrder) {
            labelText = this.getLocalZOrder();
        } else if (this._slotName) {
            labelText = this._slotName.replace("slot_", "");
        } else if (options.showPosition) {
            labelText = getMsg("\n");
        } else {
            labelText = `${this.getContentSize().width} x ${this.getContentSize().height} ${this.debugGetName()}`;
        }

        const label = this.labelSavedPtr = cleverapps.UI.generateOnlyText("", cleverapps.styles.FONTS.SYSTEM);
        label.setAnchorPoint(0, 0);
        label.setLocalZOrder(10);
        this.addChild(label);

        const superSetString = label.setString;
        label.setString = function (...args) {
            superSetString.call(label, ...args);
            label.setPosition(this.scaleX < 0 ? this.width : 0, this.scaleY < 0 ? 0 : this.height * labelDPR);
            label.setScaleX(1 / (this.scaleX / labelDPR));
            label.setScaleY(1 / (this.scaleY / labelDPR));

            const worldPosition = label.parent.convertToWorldSpace(label.getPosition());
            if (worldPosition.y > cleverapps.resolution.getBgSize().height) {
                label.y = this.scaleY < 0 ? this.height * labelDPR : -label.height * label.scaleY;
            }
        }.bind(this);
        label.setString(labelText);
    }

    if (options.showAttributes && cleverapps.flags.nodeDebugPanelMode) {
        this.showNodeDebugPanel();
    }
};

cc.Base.prototype.debugPrefab = function () {
    if (!cleverapps.config.debugMode) {
        return;
    }
    
    const contentSize = this.getContentSize();

    let sprite;
    const color = new cc.Color(0, 255, 0, 255);
    if (contentSize.width === 0 && contentSize.height === 0) {
        sprite = new cc.DrawNode();
        sprite.drawDot(cc.p(0, 0), 5, color);
    } else {
        sprite = cleverapps.UI.createScale9Sprite(bundles.dev_resources.frames.border, cleverapps.UI.Scale9Rect.TwoPixelY);
        sprite.setAnchorPoint(0, 0);
        sprite.setContentSize(contentSize);
    }
    this.spritePrefabPointer = sprite;
    sprite.setColor(color);

    const button = this.createEditPrefabButton();

    if (button) {
        button.setAnchorPoint(0, 1);
        button.setAlignment(cleverapps.styles.NodeDebug.prefabButton);
        sprite.addChild(button);
        this.prefabButton = button;
    }

    this.addChild(sprite);
    sprite.setLocalZOrder(10);
};

cc.Base.prototype.createEditPrefabButton = function () {
    const styles = cleverapps.styles.NodeDebug.prefabButton;

    let button;
    const source = this._prefabSource;

    if (!source) {
        return;
    }
    const resolved = source.resolve && source.resolve();
    const originalPath = resolved && (resolved.originalPath && resolved.originalPath()) || resolved.url;
    if (originalPath) {
        let repo = originalPath.substring(0, originalPath.indexOf("/"));
        let resPath = originalPath.substring(repo.length);

        if (repo === "res") {
            repo = cleverapps.config.name;
            resPath = `/${originalPath}`;
        }

        const prefabGitLink = `https://github.com/Clever-Apps-Pte-Ltd/${repo}/tree/master${resPath}`;

        button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.small_button_green,
            content: cleverapps.UI.generateOnlyText("P", cleverapps.UI.Button.WorkFont()),
            onClicked: function () {
                connector.platform.openUrl(prefabGitLink);
            },
            hint: "Open prefab config",
            width: styles.width,
            height: styles.height
        });
        button.alwaysOn = true;

        return button;
    }
};

cc.Base.prototype.showNodeDebugPanel = function () {
    this.setCascadeOpacityEnabledRecursively(true);
    this.setRecCascadeColorEnabled(true);
    this.debugButtons && this.debugButtons.setCascadeColorEnabled(false);

    const container = cleverapps.nodeAttributesPannel = document.createElement("div");
    Object.assign(container.style, {
        position: "absolute",
        padding: "3px",
        backgroundColor: "rgb(0, 0, 34)",
        bottom: "0px",
        right: "0px",
        display: "grid",
        "grid-template-columns": "auto auto",
        "justify-items": "center",
        "align-items": "center"
    });
    container.ondragstart = function () {
        return false;
    };
    container.onmousedown = function (e) {
        const coords = getCoords(container);
        const shiftX = e.pageX - coords.left;
        const shiftY = e.pageY - coords.top;
        moveAt(e);
        function moveAt(e) {
            container.style.bottom = "";
            container.style.right = "";
            container.style.left = `${e.pageX - shiftX}px`;
            container.style.top = `${e.pageY - shiftY}px`;
        }

        document.onmousemove = function (e) {
            moveAt(e);
        };

        document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
        };

        function getCoords(elem) { // кроме IE8-
            const box = elem.getBoundingClientRect();
            return {
                top: box.top,
                left: box.left
            };
        }
    };

    const addRange = function (innerText, min, max, step, value, callback) {
        const input = document.createElement("input");
        input.type = "range";
        input.min = String(min);
        input.max = String(max);
        input.step = String(step);
        input.value = String(value || max);
        input.style.width = "200px";
        input.style.height = "40px";
        input.oninput = input.onchange = function () {
            callback(parseFloat(input.value));
        };
        input.onmousedown = function (event) {
            event.stopPropagation();
        };
        input.onwheel = function (event) {
            event.preventDefault();
            input.value = String(parseFloat(input.value) + (event.deltaY >= 0 ? -1 : 1) * step);
            callback(parseFloat(input.value));
        };

        const text = document.createElement("div");
        text.innerText = innerText;

        container.appendChild(text);
        container.appendChild(input);
    };

    addRange("red", 0, 255, 1, this.color.r, (value) => {
        const color = this.color;
        color.r = value;
        cleverapps.sceneDebugger.selectedNode.setColor(color);
    });

    addRange("green", 0, 255, 1, this.color.g, (value) => {
        const color = this.color;
        color.g = value;
        cleverapps.sceneDebugger.selectedNode.setColor(color);
    });

    addRange("blue", 0, 255, 1, this.color.b, (value) => {
        const color = this.color;
        color.b = value;
        cleverapps.sceneDebugger.selectedNode.setColor(color);
    });

    addRange("opacity", 0, 255, 1, this.opacity, (value) => {
        this.opacity = value;
    });

    cc.container.appendChild(container);
};

cc.Base.prototype.showUnpackedRes = function () {
    let depth = 0;
    const maxDepth = 10;
    let firstLink = undefined;

    const step = function (node) {
        if (maxDepth > depth++) {
            node.getChildren().forEach((child) => {
                step(child);
            });
        }

        if (node instanceof cc.Sprite || node instanceof cc.Scale9Sprite) {
            const virtualResource = node.virtualResource;
            if (virtualResource) {
                const originalPath = virtualResource.resolve().originalPath();

                if (originalPath) {
                    let repo = originalPath.substring(0, originalPath.indexOf("/"));
                    let resPath = originalPath.substring(repo.length);

                    if (repo === "res") {
                        repo = cleverapps.config.name;
                        resPath = `/${originalPath}`;
                    }

                    if (!resPath.includes("dev_resources")) {
                        const link = `https://github.com/Clever-Apps-Pte-Ltd/${repo}/tree/master${resPath}`;
                        firstLink = firstLink || link;
                        console.log(`${virtualResource.toString()}\n${link}`);
                    }
                }
            }
        }
        if (node.constructor === sp.SkeletonAnimation) {
            const spineData = cleverapps.Spine.getGitPath(node.jsonName);
            if (spineData) {
                firstLink = firstLink || spineData.link;
                console.log(`${spineData.name}\n${spineData.link}`);
            }
        }
    };

    step(this);
    return firstLink;
};

cc.Base.prototype.createEditButtons = function (options) {
    delete this.debugEditUnitAnchorsMode;

    if (options.noResLinks) {
        return;
    }

    const styles = cleverapps.styles.NodeDebug.button;

    const createButton = function (options) {
        const button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.small_button_green,
            content: options.content,
            onClicked: options.onClicked,
            hint: options.hint,
            width: styles.width,
            height: styles.height
        });

        button.alwaysOn = true;

        return button;
    };

    let editLink, editAnchorsButton, updateAnchorsButton, updateGroundedVisibility, demoLink;
    const unitView = typeof UnitView !== "undefined" && cc.Base.GetHierarchy(this).find((node) => node instanceof UnitView);

    const link = this instanceof cc.LabelTTF ? this.showLinkToLocalization() : this.showUnpackedRes();
    if (link) {
        editLink = createButton({
            content: new cc.Sprite(bundles.dev_buttons.frames.icon_edit),
            hint: "Open link to git",
            onClicked: function () {
                if (this instanceof cc.LabelTTF) {
                    const debugTextCode = this.debugLocalizationCode || Messages.debugTextCodes[this.getString().toLowerCase().replace(/\s/g, ".")];
                    if (debugTextCode) {
                        cleverapps.copyToClipboard(debugTextCode);
                    }
                }

                connector.platform.openUrl(link);
            }.bind(this)
        });
    }

    if (cleverapps.git && unitView) {
        const isLogged = cleverapps.git.getUserName() !== undefined;

        editAnchorsButton = createButton({
            content: cleverapps.UI.generateOnlyText("A", cleverapps.UI.Button.WorkFont()),
            hint: "Toggle edit anchors mode",
            onClicked: () => {
                if (!isLogged) {
                    AdminAccess.login();
                    return;
                }

                if (cleverapps.flags.keyboardAnchorsMode) {
                    cleverapps.notification.create("Disable anchors mode in debug tool (or press 'a').");
                    return;
                }

                this.setDebugEditUnitAnchorsMode(!this.debugEditUnitAnchorsMode);

                updateAnchorsButton();

                cleverapps.notification.create(`Edit anchors mode ${this.debugEditUnitAnchorsMode ? "activated" : "switched off"}`);

                if (this !== unitView && this.debugEditUnitAnchorsMode) {
                    cleverapps.sceneDebugger.selectNode(unitView);
                    unitView.setDebugEditUnitAnchorsMode(true);
                }
            }
        });
        if (!isLogged) {
            editAnchorsButton.setCascadeOpacityEnabledRecursively(true);
            editAnchorsButton.setOpacity(120);
        }

        updateAnchorsButton = () => {
            editAnchorsButton.setType(cleverapps.flags.keyboardAnchorsMode || this.debugEditUnitAnchorsMode ? cleverapps.styles.UI.Button.Images.small_button_blue : cleverapps.styles.UI.Button.Images.small_button_green);
        };

        updateGroundedVisibility = () => {
            const grounded = typeof Grounded !== "undefined" && unitView.unit.findComponent(Grounded);
            if (!grounded || !grounded.view) {
                return;
            }

            const visible = !(cleverapps.flags.keyboardAnchorsMode || this.debugEditUnitAnchorsMode);
            grounded.view.setVisible(visible);
            unitView.debugHiddenGrounded = visible ? undefined : grounded.view;
        };

        cleverapps.flags.on("change:keyboardAnchorsMode", () => {
            updateAnchorsButton();
            updateGroundedVisibility();
        }, editAnchorsButton);

        updateAnchorsButton();
        updateGroundedVisibility();
    }

    if (unitView && unitView.unit && unitView.unit.code && Families[unitView.unit.code].units[0].mission) {
        demoLink = createButton({
            content: new cc.Sprite(bundles.dev_buttons.frames.icon_stages),
            hint: "Open unit demo",
            onClicked: function () {
                const url = cleverapps.RestClient.standsWeb(`/?unitsDemo=${cleverapps.meta.selectedLocationId()}&code=${unitView.unit.code}`);
                connector.platform.openUrl(url);
            }
        });
    }

    this.setDebugEditUnitAnchorsMode = function (debugEditUnitAnchorsMode) {
        this.debugEditUnitAnchorsMode = debugEditUnitAnchorsMode;

        updateAnchorsButton && updateAnchorsButton();
        updateGroundedVisibility && updateGroundedVisibility();
    };

    const buttons = [editLink, editAnchorsButton, demoLink, this.createEditPrefabButton()].filter(Boolean);
    if (!buttons.length) {
        return;
    }

    return new cleverapps.Layout(buttons, {
        direction: cleverapps.UI.HORIZONTAL,
        margin: styles.margin
    });
};

cc.Base.prototype.showGitLink = function () {
    if (this instanceof cc.LabelTTF) {
        return this.showLinkToLocalization();
    }
};

cc.Base.prototype.showLinkToLocalization = function () {
    if (typeof Messages === "undefined") {
        return;
    }

    const getLink = function (code) {
        const originalPath = Messages.getLinkToCode(code);
        if (originalPath) {
            let folder = originalPath.substring(0, originalPath.indexOf("/"));
            let path;
            if (folder === "res") {
                folder = cleverapps.config.name;
                path = `/${originalPath}`;
            } else {
                path = originalPath.substring(originalPath.indexOf("/"));
            }

            path += `?key=${code}`;
            return `https://github.com/Clever-Apps-Pte-Ltd/${folder}/edit/master${path}`;
        }
    };

    const debugTextCode = this.debugLocalizationCode || Messages.debugTextCodes[this.getString().toLowerCase().replace(/\s/g, ".")];

    const link = getLink(debugTextCode);
    const code = debugTextCode || this.getString();
    const msg = Messages.has(code) || code;

    if (link) {
        console.log(`${code}\n${msg}\n${link}`);
    } else {
        cleverapps.throwAsync(`no link found for ${debugTextCode}`);
    }
    return link;
};

cc.Base.prototype.cleanupBorder = function (options) {
    options = options || {};

    if (this.spritePrefabPointer) {
        this.spritePrefabPointer.removeFromParent();
        delete this.spritePrefabPointer;
        delete this.prefabButton;
    }

    if (this.spriteSavedPtr && this.spriteSavedPtr.permanent && !options.permanent) {
        if (this.labelSavedPtr) {
            this.labelSavedPtr.removeFromParent();
            delete this.labelSavedPtr;
        }

        return;
    }

    if (this.spriteSavedPtr) {
        this.spriteSavedPtr.removeFromParent();
        delete this.spriteSavedPtr;
    }
    if (this.labelSavedPtr) {
        this.labelSavedPtr.removeFromParent();
        delete this.labelSavedPtr;
    }
    if (this.debugBorderKeyHandler) {
        document.removeEventListener("keydown", this.debugBorderKeyHandler);
        delete this.debugBorderKeyHandler;
    }

    if (typeof selectedNode === "object" && selectedNode === this) {
        selectedNode = undefined;
    }

    if (cleverapps.sceneDebugger.selectedNode === this) {
        cleverapps.sceneDebugger.selectedNode = undefined;

        if (cleverapps.toolModel.isOpened()) {
            cleverapps.toolModel.refresh();
        }
    }

    if (cleverapps.nodeAttributesPannel) {
        cleverapps.nodeAttributesPannel.remove();
        cleverapps.nodeAttributesPannel = undefined;
    }

    if (typeof UnitView !== "undefined") {
        const unitView = cc.Base.GetHierarchy(this).find((node) => node instanceof UnitView);
        if (unitView) {
            if (unitView.hideTouchArea) {
                unitView.hideTouchArea();
            }

            if (unitView.debugHiddenGrounded) {
                unitView.debugHiddenGrounded.setVisible(true);
                unitView.debugHiddenGrounded = undefined;
            }
        }
    }
};

cc.Base.prototype.clearRects = function () {
    if (this.drawRectsNode) {
        this.drawRectsNode.removeFromParent();
        this.drawRectsNode = undefined;
    }
};

cc.Base.prototype.drawRects = function (worldRects, noCleanup) {
    if (!noCleanup) {
        this.clearRects();
    }

    if (!this.drawRectsNode) {
        this.drawRectsNode = new cc.DrawNode();
        this.drawRectsNode.setAnchorPoint(0, 0);
        this.drawRectsNode.setContentSize2(this.width, this.height);
        this.drawRectsNode.setLocalZOrder(10000);
        this.addChild(this.drawRectsNode);

        this.drawRectsNode.getBoundingBoxToWorld = function () {
            return cc.rect();
        };
    }

    worldRects.forEach((worldRect) => {
        const transform = this.getWorldToNodeTransform();
        const rect = cc.rectApplyAffineTransform(worldRect, transform);

        this.drawRectsNode.drawRect(cc.p(rect.x, rect.y), cc.p(rect.x + rect.width, rect.y + rect.height), null, 4, cc.color(255, 0, 0, 255));

        const positions = [{
            x: rect.x,
            y: rect.y + rect.height,
            anchorX: 0,
            anchorY: 0
        }, {
            x: rect.x + rect.width,
            y: rect.y + rect.height,
            anchorX: 1,
            anchorY: 0
        }, {
            x: rect.x,
            y: rect.y,
            anchorX: 0,
            anchorY: 1
        }, {
            x: rect.x + rect.width,
            y: rect.y,
            anchorX: 1,
            anchorY: 1
        }];

        const label = cleverapps.UI.generateOnlyText(worldRect.name || "Noname", cleverapps.styles.FONTS.SYSTEM);
        this.drawRectsNode.addChild(label);

        for (let i = 0; i < positions.length; ++i) {
            const position = positions[i];

            label.setAnchorPoint(position.anchorX, position.anchorY);
            label.setPosition(position.x, position.y);

            if (cleverapps.UI.isNodeOnScene(label)) {
                break;
            }
        }
    });
};

cc.Base.prototype.findNodeRecursively = function (instanceId) {
    if (this.__instanceId === instanceId) {
        return this;
    }

    for (const child of this.children) {
        const found = child.findNodeRecursively(instanceId);
        if (found) {
            return found;
        }
    }
};

// eslint-disable-next-line no-unused-vars
const previewRes = function (path) {
    const addToScene = function (res) {
        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(res);
        res.setAlignment(scene.width / 2, scene.height / 2);
    };

    if (path instanceof VirtualJson) {
        const createSpine = function () {
            const res = new cleverapps.Spine(path);
            const animations = Object.keys(res.data.animations);
            res.setAnimation(0, animations[0], true);
            res.setSkin(res.listSkins()[0] || "default");
            res.debugBorder();

            addToScene(res);
            console.log(animations);
        };

        path = cleverapps.skins.getSlot("spine", { json: path }).resolve();

        if (cleverapps.bundleLoader.isLoaded(path.bundleName)) {
            createSpine();
        } else {
            cleverapps.bundleLoader.loadBundle(path.bundleName, {
                onSuccess: createSpine
            });
        }
    } else if (path instanceof SpriteFrame) {
        addToScene(cleverapps.UI.createScale9Sprite(path));
    }
};

// eslint-disable-next-line no-unused-vars
const checkFonts = function (testFont) {
    const items = [];
    testFont = testFont || {};

    for (let size = 15; size < 90; size += 5) {
        const font = {
            name: testFont.name || "default", size, fnt: true, stroke: testFont.stroke, shadow: testFont.shadow
        };

        const one = cleverapps.UI.generateOnlyText("1235", font);
        const two = cleverapps.UI.generateImageText("1235", font);
        const some = new cleverapps.Layout([one, two], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: 5
        });
        items.push(some);
    }

    const res = new cleverapps.Layout(items, {
        direction: cleverapps.UI.VERTICAL,
        margin: 5
    });

    cleverapps.Scenes.GetRunningScene().addChild(res);
    res.setAlignment(cleverapps.resolution.getSceneSize().width / 2, cleverapps.resolution.getSceneSize().height / 2);
};

// eslint-disable-next-line no-unused-vars
const drawDebugRect = function (rect, color) {
    const fillColor = new cc.Color(0, 0, 0, 0);
    color = color || new cc.Color(255, 0, 0, 255);

    const scene = cleverapps.Scenes.GetRunningScene();
    const position = scene.convertToNodeSpace(cc.rect(rect));
    const newRect = cc.rect(position.x, position.y, rect.width, rect.height);

    const node = new cc.DrawNode();
    node.setContentSize2(newRect.width, newRect.height);
    node.setAlignment(newRect.x, newRect.y);
    node.drawRect(cc.p(0, 0), cc.p(newRect.width, newRect.height), fillColor, 3, color);
    node.setLocalZOrder(1000);

    scene.addChild(node);

    return node;
};

cleverapps.styles.NodeDebug = {
    button: {
        x: { align: "right", dx: 50 },
        y: { align: "top" },
        width: 50,
        height: 50,
        margin: 5
    },

    prefabButton: {
        x: { align: "right", dx: 50 },
        y: { align: "top", dy: 50 },
        width: 50,
        height: 50
    }
};
